import React, { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import styled from 'styled-components';

import { CosmosComponent, InteractorType } from '../../types';

type CheckboxType = Exclude<InteractorType, 'incrementor'>;
export type CheckboxHandler = (value?: boolean, name?: string) => void;

export interface CheckboxProps
  extends CosmosComponent,
    InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  groupName?: string;
  name?: string;
  type?: CheckboxType;
  handler?: CheckboxHandler;
  selectedRef?: any;
}

export const Checkbox: FC<CheckboxProps> = ({
  className,
  checked,
  name,
  groupName,
  type = 'checkbox',
  handler,
  selectedRef,
  testId,
  ...props
}) => (
  <StyledCheckbox
    checked={checked}
    name={type === 'checkbox' ? name : groupName}
    type={type}
    className={className}
    onChange={(event: ChangeEvent<HTMLInputElement>) =>
      handler?.(event.target.checked, name)
    }
    data-test-id={testId}
    ref={selectedRef}
    {...props}
  />
);

const StyledCheckbox = styled.input`
  appearance: none;
  display: flex;
  flex-shrink: 0;
  position: relative;
  height: 18px;
  width: 18px;
  border-radius: 0.2em;
  border: 2px solid ${({ theme: { colors } }) => colors?.primerGrey};
  background-color: ${({ theme: { colors } }) => colors?.white};
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;
  ${({ theme }) => theme?.overrides?.Checkbox}

  &:checked {
    background-color: ${({ theme: { colors } }) => colors?.r2d2Blue};
    border: 2px solid ${({ theme: { colors } }) => colors?.r2d2Blue};
    height: 18px;
    width: 18px;
    ${({ theme }) => theme?.overrides?.Checkbox.checked}
    &::before {
      height: 30%;
      width: 70%;
      content: '';
      border: 2px solid ${({ theme: { colors } }) => colors?.white};
      border-top: none;
      border-right: none;
      margin: auto;
      margin-bottom: 35%;
      transform: rotate(-45deg);
      box-sizing: content-box;
      ${({ theme }) => theme?.overrides?.Checkbox.before}
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
    ${({ theme }) => theme?.overrides?.Checkbox.disabled}
  }

  &[type='radio'] {
    border-radius: 50%;
    ${({ theme }) => theme?.overrides?.Checkbox.radio}
  }
`;
